import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableOrgBillingHistory = Loadable({
  loader: function loader() {
    return import('../OrgBillingHistory.jsx');
  },
  loading: ComponentLoading
});
export default LoadableOrgBillingHistory;